import React from 'react';
import { QuicksightHome } from './QuicksightHome';

export const Quicksight = () => {

  return (
    <QuicksightHome />
  )
}
